
Vue.component("course_overview_panel", {
    props: {
        list: {},
        can_click: {
            default: true
        },
        video_id: {
            //单画面
            default: ''
        },
        video_ids: {
            //多画面
            default: []
        },
        show_knowledge_point: {
            default: true
        },
        fragment: {
          type: Array,
          required: false,
          default: []
        },
    },
    data() {
        return {
            activeId: '',
            currentId: '',//当前资源id
            knowledgeList: [],
            keywordAndAbstract: {},//关键词和摘要
            dataList: [], //多分屏本节概览下拉
            currentSelected: '',//下拉选中
            hasKnowledgeEssentials: false,//是否有知识要点
            hasData: false,//是否有数据
        }
    },
    watch: {
        video_id: {
            handler(newVal) {
                this.currentId = newVal
                newVal && this.getData()
            },
            immediate: true,
        },
        video_ids: {
            handler(newVal) {
                newVal && newVal.length && this.getMultipleData()
            },
            immediate: true,
        },
        hasData: {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.$emit('if_active', newVal)
                }
            }
        },
    },
    methods: {
        getQueryString(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            var r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        },
        async getMultipleData() {
            // console.log('video_ids', this.video_ids)
            let knowledgeList = []
            let keywordAndAbstract = []
            //获取所有画面知识点
            await Promise.all(this.video_ids.map(el => API.reqKnowladgePointList({ contentId: el.videoId, isSysAuth: false }))).then(arr => {
                arr.map((el, i) => {
                    if (el.success) {
                        knowledgeList.push(el.data?.data)
                    } else {
                        knowledgeList.push([])
                    }
                })
            })
            //获取所有画面摘要和关键词
            await Promise.all(this.video_ids.map(el => API.reqKeywordAndAbstract({ videoId: el.videoId }))).then(arr => {
                arr.map((el, i) => {
                    if (el.status == 200) {
                        keywordAndAbstract.push(el.data)
                    } else {
                        keywordAndAbstract.push({})
                    }
                })
            })
            let dataList = this.video_ids.map((el, i) => {
                return {
                    name: el.name,
                    guid: el.videoId,
                    knowledgeList: knowledgeList[i].sort((a, b) => a.inpoint - b.inpoint),
                    keywordAndAbstract: keywordAndAbstract[i]
                }
            })
            // .filter(el => {
            //     return el.knowledgeList.length > 0 || (el.keywordAndAbstract.keyword && el.keywordAndAbstract.keyword.length) || (el.keywordAndAbstract.description && el.keywordAndAbstract.description.length)
            // })
            if (dataList.length > 0) {
                let bannerPlateType = window.bannerPlateType
                this.dataList = dataList
                let defaultIndex = dataList.findIndex(el => {
                    if (bannerPlateType == 9) {
                        return el.name.includes("教师全景")
                    } else {
                        return el.name.includes('导切') || el.name.includes('屏幕')
                    }
                })
                defaultIndex = defaultIndex > -1 ? defaultIndex : 0
                this.handleSelectChange(defaultIndex)
                this.hasData = true
            } else {
                this.hasData = this.hasData || false
            }

        },
        getData() {
            const that = this
            //获取知识点列表
            //获取摘要和关键词
            Promise.all([API.reqKnowladgePoint({
                videoId: this.video_id,
            }), API.reqKeywordAndAbstract({
                videoId: this.video_id,
            })]).then(arr => {
                this.knowledgeList = ((arr[0] && arr[0].status == 200) ? arr[0].data : []).sort((a, b) => a.inpoint - b.inpoint);
                this.keywordAndAbstract = (arr[1] && arr[1].status == 200) ? arr[1].data : {}

                if (this.bannerPlateType == 9) {
                    this.hasData = this.hasData || Boolean(this.keywordAndAbstract.keyword.length || this.keywordAndAbstract.description)
                } else {
                    this.hasData = this.hasData || (Boolean(this.knowledgeList.length || this.keywordAndAbstract.keyword.length || this.keywordAndAbstract.description))
                }
                if (this.getQueryString('pointId')) {
                    setTimeout(() => {
                        that.pointHandleById(that.getQueryString('pointId'))
                    }, 1000);
                }
            }).catch(err => {
                this.hasData = this.hasData || false
            })
        },
        pointHandle(point, ifScroll) {
            // console.log(this.can_click)
            if (!this.can_click) {
                this.$message.error("请先完成第一遍学习")
                return;
            }
            let { inpoint, outpoint } = point;
            inpoint = inpoint / 10000000;
            outpoint = outpoint / 10000000;
            this.$emit("change", {
                ...point,
                inpoint,
                outpoint,
                currentTime: inpoint
            });
            this.activeId = point.guid_
            if (ifScroll) {
                this.$nextTick(() => {
                    this.$refs['point_item_' + point.guid_] && this.$refs['point_item_' + point.guid_][0].scrollIntoView({ block: 'center' })
                })
            }
        },
        pointHandleById(id) {
            let point = this.knowledgeList.find(el => el.guid_ == id)
            this.pointHandle(point, true)
        },
        handleSelectChange(index) {
            this.currentId = this.dataList[index].guid
            this.currentSelected = index
            this.knowledgeList = this.dataList[index].knowledgeList
            this.keywordAndAbstract = this.dataList[index].keywordAndAbstract
            this.$emit('screen_change', { seat: this.dataList[index]?.name, guid: this.dataList[index]?.guid })
        },
        onKnowledgeEssentialsSeek(point) {
            let { currentTime } = point;
            this.$emit("change", {
                ...point,
                inpoint: currentTime,
            });
        },
        onIfShowKnowledgeEssentials(flag) {
            this.hasKnowledgeEssentials = flag
            if (flag) {
                this.hasData = true
            } else {
                this.hasData = this.hasData || false
            }
        }
    },
    template: `
  <div class="course_overview_panel">
      <el-select v-if="dataList.length" size="small" v-model="currentSelected" placeholder="请选择" @change="handleSelectChange">
        <el-option
            v-for="(item,i) in dataList"
            :key="i"
            :label="item.name"
            :value="i">
        </el-option>
      </el-select>
      <div class="overview_wrap" v-if="keywordAndAbstract.description" style="margin-bottom: 16px;">
          <div class="title">{{$t('本节摘要')}}</div>
          <div class="detail">
            <text-clamp :text="keywordAndAbstract.description">
                <template v-slot:default="{ clickToggle, expanded }">
                    <a @click="clickToggle" class="open_close_btn">
                        {{ expanded ? $t("收起 ∧") : $t("展开全部 ∨") }}
                    </a>
                </template>
            </text-clamp>
          </div>
      </div>
      <template v-if="keywordAndAbstract.keyword && keywordAndAbstract.keyword.length">
        <div class="sub_title">{{$t('关键词')}}</div>
        <div class="keyword_list" style="margin-bottom: 30px;">
            <div class="item" v-for="keyword in keywordAndAbstract.keyword || []">{{keyword}}</div>
        </div>
      </template>
      <!-- 上科不显示知识点 -->
      <template v-if="show_knowledge_point && bannerPlateType != 9">
        <div class="sub_title">{{$t('知识点')}}</div>
        <div class="course_knowledge_panel">
            <div :class="{user_knowledge_item:true,active:point.guid_ == activeId}" v-for="(point,i) in knowledgeList" @click="pointHandle(point)" :ref="'point_item_' + point.guid_" :key="i">
                <div class="time">{{point.inpoint | l100Ns2Tc$1}}-{{point.outpoint | l100Ns2Tc$1}}</div>
                <div class="user_knowledge_content">
                    <img class="user_knowledge_cover" :src="point.keyframepath?point.keyframepath:point.cover?point.cover:'/learn/static/imgs/default_video_cover.png'" alt="">
                    <span class="name">{{point.title}}</span>
                </div>
            </div>
        </div>
      </template>
      <!-- 上科显示知识要点 -->
      <template v-if="bannerPlateType == 9">
        <div v-show="hasKnowledgeEssentials">
            <div class="sub_title">{{$t('摘要')}}</div>
            <knowledge_essentials_panel :resourse_id="currentId" @if_show="onIfShowKnowledgeEssentials" @seek="onKnowledgeEssentialsSeek" :fragment="fragment"></knowledge_essentials_panel>
        </div>
      </template>
      <el-empty v-if="!knowledgeList.length && (bannerPlateType == 9?!hasKnowledgeEssentials:true)"></el-empty>
  </div>
  `,
});